export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["LoadDebugFlags"] = "[DebugFlags] Load Flags";
    ActionTypes["LoadDebugFlagsSuccess"] = "[DebugFlags] Load Flags Success";
    ActionTypes["SetDebugFlags"] = "[DebugFlags] Set Flags";
})(ActionTypes || (ActionTypes = {}));
export class Set {
    constructor(payload) {
        this.payload = payload;
        this.type = ActionTypes.SetDebugFlags;
    }
}
export class Load {
    constructor() {
        this.type = ActionTypes.LoadDebugFlags;
    }
}
export class LoadSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = ActionTypes.LoadDebugFlagsSuccess;
    }
}
//# sourceMappingURL=debug-flag.actions.js.map